module.exports = __webpack_public_path__ + "img/bcc075.4734a23d.jpeg";